import diaSubFormStrategy from "./diaManualFormStrategy";
import iptManualFormStrategy from "./iptManualForm.strategy";
import biaManualFormStrategy from "./biaManualForm.strategy";
import wiaManualFormStrategy from "./wiaManualForm.strategy";
import ipAddressManualFormStrategy from "./ipAddressManualForm.strategy";
import eplManualFormStrategy from "./eplManualForm.strategy";
import networkManualFormStrategy from "./networkManualForm.strategy";
import fieldServiceManualFormStrategy from "./fieldServiceManualForm.strategy";
import rackAndSpaceManualFormStrategy from "./rackAndSpaceManualForm.strategy";
import crossConnectManualFormStrategy from "./crossConnectManualForm.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";

const manualQuoteForms = {
  [QUOTES_TYPE[0]]: diaSubFormStrategy,
  [QUOTES_TYPE[1]]: iptManualFormStrategy,
  [QUOTES_TYPE[2]]: biaManualFormStrategy,
  [QUOTES_TYPE[3]]: wiaManualFormStrategy,
  [QUOTES_TYPE[4]]: ipAddressManualFormStrategy,
  [QUOTES_TYPE[5]]: eplManualFormStrategy,
  [QUOTES_TYPE[6]]: eplManualFormStrategy,
  [QUOTES_TYPE[7]]: networkManualFormStrategy,
  [QUOTES_TYPE[8]]: fieldServiceManualFormStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceManualFormStrategy,
  [QUOTES_TYPE[10]]: crossConnectManualFormStrategy,
};

export default manualQuoteForms;
